import { RouterModule } from '@angular/router';
import { Component, ViewChild, ElementRef, HostListener, PLATFORM_ID, Inject, OnInit } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { GoogleTagManagerService } from '../angular-google-tag-manager.service';
import { CountdownTimerComponent } from './countdown-timer/countdown-timer.component';
import { SeasonResultsSectionComponent } from './season-results-section/season-results-section.component';
import { FeaturesAndResultsSectionComponent } from './features-and-results-section/features-and-results-section.component';
import { TestimonialsSectionComponent } from './testimonials-section/testimonials-section.component';
import { BenefitsSectionComponent } from './benefits-section/benefits-section.component';
import { ClosingSectionsComponent } from './closing-sections/closing-sections.component';
import { FaqSectionComponent } from './faq-section/faq-section.component';
import { PricingCardComponent } from './pricing-card/pricing-card.component';
import { SeoService } from '../services/seo.service'; 

interface StatItem {
  iconUrl: string;
  label: string;
  value: string;
}

@Component({
    selector: 'app-platinum-page',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        CountdownTimerComponent,
        SeasonResultsSectionComponent,
        FeaturesAndResultsSectionComponent,
        TestimonialsSectionComponent,
        BenefitsSectionComponent,
        ClosingSectionsComponent,
        FaqSectionComponent,
        PricingCardComponent
    ],
    templateUrl: './platinum-page.component.html',
    styleUrls: ['./platinum-page.component.scss']
})
export class PlatinumPageComponent implements OnInit{
    
    @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
    isBrowser: boolean = false;
    
    stats: StatItem[] = [
        { iconUrl: 'https://imgix.cosmicjs.com/2d20d170-5a7e-11f0-ae5a-0f56aa053fcd-dollar-sign-1.svg', label: 'Units', value: '+42.06' },
        { iconUrl: 'https://imgix.cosmicjs.com/2d234270-5a7e-11f0-ae5a-0f56aa053fcd-locate-fixed.svg', label: 'Strike rate', value: '69%' },
        { iconUrl: 'https://imgix.cosmicjs.com/2d258c60-5a7e-11f0-ae5a-0f56aa053fcd-line-chart.svg', label: 'ROI', value: '+28.38%' },
        { iconUrl: 'https://imgix.cosmicjs.com/2d260190-5a7e-11f0-ae5a-0f56aa053fcd-shield-check.svg', label: 'Wins', value: '105' },
        { iconUrl: 'https://imgix.cosmicjs.com/2d24c910-5a7e-11f0-ae5a-0f56aa053fcd-shield-x.svg', label: 'Losses', value: '46' },
        { iconUrl: 'https://imgix.cosmicjs.com/2d242cd0-5a7e-11f0-ae5a-0f56aa053fcd-shield-minus.svg', label: 'Push/Voids', value: '2' },
    ];

    constructor(
        private gtmService: GoogleTagManagerService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private seoService: SeoService
    ) {
           this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        this.seoService.updateTags(
            'AI Football Predictions That Actually Win | Dimers Platinum',
            ' Unlock the power of AI football predictions with Dimers Platinum. Our artificial intelligence football predictor delivers smarter picks and real results.');
    }

    ngAfterViewInit() {
        if (this.videoPlayer && this.isBrowser) {
            const video = this.videoPlayer.nativeElement;

            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    console.warn('video has been prevented to play', error);
                });
            }
        }
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (this.videoPlayer) {
            const video = this.videoPlayer.nativeElement;
            if (video.paused) {
                video.play().catch(e => console.error('video still not playing', e));
            }
        }
    }

    jumpToSection(sectionId: string): void {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        } else {
            console.warn(`Section with ID ${sectionId} not found.`);
        }
    }
}
